// extracted by mini-css-extract-plugin
module.exports = {"block":"rules_block__92hUf","content":"rules_content__Ny7H6"};